export default {
  noAccountDetail: 'No Account Info was found for {}',
  noPricingItem: 'No Item info was found for {}',
  noPriceOffer: 'No Price Offer info was found for {}',
  noPricingBundle: 'No Bundle info was found for {}',
  noPricingPackage: 'No Package info was found for {}',
  noPricingDependency: 'No Denpendency info was found for {}',
  noOrder: 'No Order info was found for {}',
};
